/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RowData } from './RowData';
import {
    RowDataFromJSON,
    RowDataFromJSONTyped,
    RowDataToJSON,
} from './RowData';
import type { RowState } from './RowState';
import {
    RowStateFromJSON,
    RowStateFromJSONTyped,
    RowStateToJSON,
} from './RowState';

/**
 * Optional Table [used by: Table]
 * @export
 * @interface Table
 */
export interface Table {
    /**
     * 
     * @type {string}
     * @memberof Table
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof Table
     */
    id: string;
    /**
     * 
     * @type {RowData}
     * @memberof Table
     */
    rowData?: RowData;
    /**
     * 
     * @type {RowState}
     * @memberof Table
     */
    rowState?: RowState;
    /**
     * 
     * @type {boolean}
     * @memberof Table
     */
    editable: boolean;
}

/**
 * Check if a given object implements the Table interface.
 */
export function instanceOfTable(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "editable" in value;

    return isInstance;
}

export function TableFromJSON(json: any): Table {
    return TableFromJSONTyped(json, false);
}

export function TableFromJSONTyped(json: any, ignoreDiscriminator: boolean): Table {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'id': json['id'],
        'rowData': !exists(json, 'rowData') ? undefined : RowDataFromJSON(json['rowData']),
        'rowState': !exists(json, 'rowState') ? undefined : RowStateFromJSON(json['rowState']),
        'editable': json['editable'],
    };
}

export function TableToJSON(value?: Table | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'id': value.id,
        'rowData': RowDataToJSON(value.rowData),
        'rowState': RowStateToJSON(value.rowState),
        'editable': value.editable,
    };
}

